var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconObject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 20V12C24.9996 11.6493 24.9071 11.3048 24.7315 11.0012C24.556 10.6975 24.3037 10.4454 24 10.27L17 6.27C16.696 6.09446 16.3511 6.00205 16 6.00205C15.6489 6.00205 15.304 6.09446 15 6.27L8 10.27C7.69626 10.4454 7.44398 10.6975 7.26846 11.0012C7.09294 11.3048 7.00036 11.6493 7 12V20C7.00036 20.3507 7.09294 20.6952 7.26846 20.9988C7.44398 21.3025 7.69626 21.5546 8 21.73L15 25.73C15.304 25.9055 15.6489 25.998 16 25.998C16.3511 25.998 16.696 25.9055 17 25.73L24 21.73C24.3037 21.5546 24.556 21.3025 24.7315 20.9988C24.9071 20.6952 24.9996 20.3507 25 20Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.27 10.96L16 16.01L24.73 10.96",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 26.08V16",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconObject);
export default __webpack_public_path__ + "static/media/icon_object.84ca9e0d6a48de38b9def255a8597eec.svg";
export { ForwardRef as ReactComponent };